import { Card, Text } from '@radix-ui/themes';
import clsx from 'clsx';
import type { ComponentProps } from 'react';
import type { ClosedMessageDocument } from '@hubertai/screening-question-types';
import type { TChatCollection } from 'types/scores.types';
import AnswerEvaluation from '../AnswerEvaluation';
import TimeStamp from '../TimeStamp';
import { EFormType, type TFormType } from '@hubertai/screening-question-types';

interface CandidateMessageProps extends ComponentProps<'div'> {
  collection: TChatCollection;
  answer: ClosedMessageDocument;
}

const AnswerValue = ({ value, fallback }: { value: ClosedMessageDocument['value']; fallback: string }) => {
  if (value === undefined) {
    return <div>{fallback}</div>;
  }
  if (value instanceof Date) {
    return <TimeStamp date={value} muted={false} />;
  }
  if (Array.isArray(value)) {
    return <div>{value.map((item) => (typeof item === 'object' ? item.text : item)).join(', ')}</div>;
  }
  return <div>{value}</div>;
};

const CandidateFormAnswer = ({ collection, answer, ...props }: CandidateMessageProps) => {
  return (
    <div {...props} className={clsx('flex flex-row justify-end gap-2')}>
      <Card className={clsx('max-w-[80%]', 'flex flex-col justify-between', 'p-2')}>
        <Text as="div" size="2" color="gray">
          {(() => {
            if (answer.form_type === undefined) {
              return <div>{answer.text ?? ''}</div>;
            }
            if (
              ([EFormType.Slider, EFormType.Text, EFormType.Number, EFormType.Email] as TFormType[]).includes(
                answer.form_type,
              )
            ) {
              return <AnswerValue value={answer.value} fallback={answer.text ?? ''} />;
            }

            return <div>{answer.text ?? ''}</div>;
          })()}
        </Text>
      </Card>

      <AnswerEvaluation
        evaluation={
          collection.evaluation && collection.evaluation.evaluation && Array.isArray(collection.evaluation.evaluation)
            ? collection.evaluation.evaluation.find((x) => x.valueId === answer.form_id)
            : undefined
        }
      />
    </div>
  );
};

export default CandidateFormAnswer;
